// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"f39b8614","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};